import { render, staticRenderFns } from "./PlansCard.vue?vue&type=template&id=7124f5bc"
import script from "./PlansCard.vue?vue&type=script&lang=js"
export * from "./PlansCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports